export const FILTER_ITEM_MAX_WIDTH = 'unset'
